(function () {
  'use strict';

  if (window.__SHOPIFY_GOOGLE_ATTR_V2__) return;
  window.__SHOPIFY_GOOGLE_ATTR_V2__ = true;

  var CFG = {
    debug: false,
    days: 30,

    // 只填写根域名，不要填写 de.xxx.de、se.xxx.de
    rootDomains: [
      'noeifevo.de',
      'wissenergy.de'
    ]
  };

  var LS = 'shopify_google_attr_v2';
  var CK = 'shopify_google_attr_v2';
  var SS = 'shopify_google_attr_sync_v2';
  var OLD = 'shopify_gclid';

  var TTL = CFG.days * 86400000;
  var MAX_AGE = CFG.days * 86400;
  var qs = new URLSearchParams(location.search || '');

  var pending = null;
  var timer = null;

  var root =
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
      ? Shopify.routes.root
      : '/';

  if (root.slice(-1) !== '/') {
    root += '/';
  }

  function log() {
    if (!CFG.debug || !window.console) return;

    console.log.apply(
      console,
      ['[Google Attribution]'].concat(
        [].slice.call(arguments)
      )
    );
  }

  function str(value) {
    return value == null
      ? ''
      : String(value).trim();
  }

  function cut(value, maxLength) {
    value = str(value);

    return value.length > maxLength
      ? value.slice(0, maxLength)
      : value;
  }

  function param(names, maxLength) {
    for (var i = 0; i < names.length; i++) {
      var value = qs.get(names[i]);

      if (
        value !== null &&
        str(value) !== ''
      ) {
        return cut(
          value,
          maxLength || 500
        );
      }
    }

    return '';
  }

  function parseJson(value) {
    try {
      return value
        ? JSON.parse(value)
        : null;
    } catch (error) {
      return null;
    }
  }

  function getRootDomain() {
    var host =
      location.hostname.toLowerCase();

    for (
      var i = 0;
      i < CFG.rootDomains.length;
      i++
    ) {
      var domain = CFG.rootDomains[i]
        .toLowerCase()
        .replace(/^\./, '');

      if (!domain) continue;

      if (
        host === domain ||
        host.slice(
          -(domain.length + 1)
        ) === '.' + domain
      ) {
        return domain;
      }
    }

    return '';
  }

  function normalize(data) {
    if (
      !data ||
      typeof data !== 'object'
    ) {
      return null;
    }

    data.gclid =
      str(data.gclid);

    data.wbraid =
      str(data.wbraid);

    data.gbraid =
      str(data.gbraid);

    data.click_id =
      str(data.click_id) ||
      data.gclid ||
      data.wbraid ||
      data.gbraid;

    data.click_type =
      str(data.click_type) ||
      (
        data.gclid
          ? 'gclid'
          : data.wbraid
            ? 'wbraid'
            : data.gbraid
              ? 'gbraid'
              : ''
      );

    [
      'campaign_id',
      'gad_campaignid',
      'adgroup_id',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_adgroup',
      'utm_term',
      'gad_source',
      'country',
      'currency',
      'landing_url',
      'referrer',
      'capture_source'
    ].forEach(function (key) {
      data[key] = str(data[key]);
    });

    data.referrer =
      data.referrer || 'direct';

    data.capture_source =
      data.capture_source || 'cache';

    data.captured_at =
      Number(data.captured_at || 0);

    return data;
  }

  function valid(data) {
    if (
      !data ||
      !data.click_id ||
      !data.captured_at
    ) {
      return false;
    }

    var age =
      Date.now() - data.captured_at;

    return (
      age >= 0 &&
      age < TTL
    );
  }

  function captureFromUrl() {
    var gclid =
      param(['gclid'], 350);

    var wbraid =
      param(['wbraid'], 350);

    var gbraid =
      param(['gbraid'], 350);

    if (
      !gclid &&
      !wbraid &&
      !gbraid
    ) {
      return null;
    }

    var gadCampaignId =
      param(
        ['gad_campaignid'],
        80
      );

    var explicitCampaignId =
      param(
        [
          'campaign_id',
          'campaignid'
        ],
        80
      );

    var utmCampaign =
      param(
        ['utm_campaign'],
        160
      );

    var utmAdgroup =
      param(
        ['utm_adgroup'],
        160
      );

    var explicitAdgroupId =
      param(
        [
          'gad_adgroupid',
          'adgroup_id',
          'adgroupid'
        ],
        80
      );

    return normalize({
      click_id:
        gclid ||
        wbraid ||
        gbraid,

      click_type:
        gclid
          ? 'gclid'
          : wbraid
            ? 'wbraid'
            : 'gbraid',

      gclid: gclid,
      wbraid: wbraid,
      gbraid: gbraid,

      campaign_id:
        gadCampaignId ||
        explicitCampaignId ||
        (
          /^\d+$/.test(utmCampaign)
            ? utmCampaign
            : ''
        ),

      gad_campaignid:
        gadCampaignId,

      adgroup_id:
        explicitAdgroupId ||
        (
          /^\d+$/.test(utmAdgroup)
            ? utmAdgroup
            : ''
        ),

      utm_source:
        param(['utm_source'], 80),

      utm_medium:
        param(['utm_medium'], 80),

      utm_campaign:
        utmCampaign,

      utm_adgroup:
        utmAdgroup,

      utm_term:
        param(['utm_term'], 160),

      gad_source:
        param(['gad_source'], 30),

      country:
        param(['country'], 10),

      currency:
        param(['currency'], 10),

      landing_url:
        cut(location.href, 1800),

      referrer:
        cut(
          document.referrer ||
          'direct',
          1000
        ),

      captured_at:
        Date.now(),

      capture_source:
        'url'
    });
  }

  function readCookie() {
    var prefix = CK + '=';
    var list = document.cookie
      ? document.cookie.split(';')
      : [];

    for (
      var i = 0;
      i < list.length;
      i++
    ) {
      var item = list[i].trim();

      if (
        item.indexOf(prefix) === 0
      ) {
        try {
          return parseJson(
            decodeURIComponent(
              item.slice(prefix.length)
            )
          );
        } catch (error) {
          return null;
        }
      }
    }

    return null;
  }

  function writeCookie(data) {
    try {
      var compact = {
        click_id:
          cut(data.click_id, 350),

        click_type:
          data.click_type,

        gclid:
          cut(data.gclid, 350),

        wbraid:
          cut(data.wbraid, 350),

        gbraid:
          cut(data.gbraid, 350),

        campaign_id:
          cut(data.campaign_id, 80),

        gad_campaignid:
          cut(data.gad_campaignid, 80),

        adgroup_id:
          cut(data.adgroup_id, 80),

        utm_source:
          cut(data.utm_source, 80),

        utm_medium:
          cut(data.utm_medium, 80),

        utm_campaign:
          cut(data.utm_campaign, 160),

        utm_adgroup:
          cut(data.utm_adgroup, 160),

        landing_url:
          cut(data.landing_url, 700),

        referrer:
          cut(data.referrer, 400),

        captured_at:
          data.captured_at
      };

      var value =
        encodeURIComponent(
          JSON.stringify(compact)
        );

      /*
       * 防止Cookie超过浏览器大小限制。
       * 如果URL过长，优先保留点击ID和广告系列ID。
       */
      if (value.length > 3600) {
        compact.landing_url = '';
        compact.referrer = '';

        value =
          encodeURIComponent(
            JSON.stringify(compact)
          );
      }

      var cookie =
        CK +
        '=' +
        value +
        '; Max-Age=' +
        MAX_AGE +
        '; Path=/' +
        '; SameSite=Lax';

      var rootDomain =
        getRootDomain();

      if (rootDomain) {
        cookie +=
          '; Domain=' +
          rootDomain;
      }

      if (
        location.protocol ===
        'https:'
      ) {
        cookie += '; Secure';
      }

      document.cookie = cookie;

    } catch (error) {
      log(
        'Cookie write failed',
        error
      );
    }
  }

  function loadStored() {
    var data = null;

    try {
      data = normalize(
        parseJson(
          localStorage.getItem(LS)
        )
      );
    } catch (error) {}

    if (valid(data)) {
      return data;
    }

    data = normalize(
      readCookie()
    );

    if (valid(data)) {
      return data;
    }

    /*
     * 兼容旧代码：
     * shopify_gclid = GCLID|时间戳
     */
    try {
      var oldValue =
        localStorage.getItem(OLD);

      if (oldValue) {
        var parts =
          oldValue.split('|');

        data = normalize({
          click_id:
            parts[0] || '',

          click_type:
            'gclid',

          gclid:
            parts[0] || '',

          captured_at:
            Number(parts[1] || 0),

          capture_source:
            'legacy_cache'
        });

        if (valid(data)) {
          return data;
        }
      }
    } catch (error) {}

    return null;
  }

  function mergeFresh(
    fresh,
    stored
  ) {
    if (
      !fresh ||
      !stored ||
      fresh.click_id !==
        stored.click_id
    ) {
      return fresh;
    }

    Object.keys(
      stored
    ).forEach(function (key) {
      if (!fresh[key]) {
        fresh[key] = stored[key];
      }
    });

    fresh.captured_at =
      Date.now();

    fresh.capture_source =
      'url';

    return normalize(fresh);
  }

  function save(data) {
    try {
      localStorage.setItem(
        LS,
        JSON.stringify(data)
      );
    } catch (error) {}

    writeCookie(data);
  }

  function clean(object) {
    Object.keys(
      object
    ).forEach(function (key) {
      if (
        str(object[key]) === ''
      ) {
        delete object[key];
      }
    });

    return object;
  }

  function createAttributes(data) {
    var type =
      data.capture_source === 'url'
        ? data.click_type
        : 'cache_old';

    /*
     * 保留旧版gclid复合字段，
     * 兼容你现有Webhook。
     */
    var legacyPayload = [
      data.click_id,
      type,

      encodeURIComponent(
        data.landing_url || ''
      ),

      encodeURIComponent(
        data.referrer ||
        'direct'
      ),

      [
        encodeURIComponent(
          data.utm_source ||
          'empty'
        ),

        encodeURIComponent(
          data.utm_medium ||
          'empty'
        ),

        encodeURIComponent(
          data.utm_campaign ||
          'empty'
        )
      ].join('|')
    ].join('--');

    return clean({
      gclid:
        cut(
          legacyPayload,
          3500
        ),

      google_click_id:
        cut(data.click_id, 350),

      google_click_type:
        data.click_type,

      google_gclid:
        cut(data.gclid, 350),

      google_wbraid:
        cut(data.wbraid, 350),

      google_gbraid:
        cut(data.gbraid, 350),

      campaign_id:
        data.campaign_id,

      gad_campaignid:
        data.gad_campaignid ||
        data.campaign_id,

      adgroup_id:
        data.adgroup_id,

      utm_source:
        data.utm_source,

      utm_medium:
        data.utm_medium,

      utm_campaign:
        data.utm_campaign,

      utm_adgroup:
        data.utm_adgroup,

      utm_term:
        data.utm_term,

      gad_source:
        data.gad_source,

      country:
        data.country,

      currency:
        data.currency,

      google_landing_url:
        cut(
          data.landing_url,
          1800
        ),

      google_referrer:
        cut(
          data.referrer,
          1000
        ),

      google_captured_at:
        new Date(
          data.captured_at
        ).toISOString()
    });
  }

  function fingerprint(data) {
    return [
      data.click_id,
      data.campaign_id,
      data.adgroup_id,
      data.captured_at
    ].join('|');
  }

  function syncToCart(
    data,
    force
  ) {
    if (
      !valid(data) ||
      !window.fetch
    ) {
      return Promise.resolve(false);
    }

    var key =
      fingerprint(data);

    try {
      if (
        !force &&
        sessionStorage.getItem(SS) ===
          key
      ) {
        return Promise.resolve(true);
      }
    } catch (error) {}

    if (pending) {
      return pending;
    }

    pending = fetch(
      root + 'cart/update.js',
      {
        method:
          'POST',

        credentials:
          'same-origin',

        keepalive:
          true,

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json'
        },

        body:
          JSON.stringify({
            attributes:
              createAttributes(data)
          })
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'HTTP ' +
            response.status
          );
        }

        try {
          sessionStorage.setItem(
            SS,
            key
          );
        } catch (error) {}

        return true;
      })
      .catch(function (error) {
        log(
          'Cart sync failed',
          error
        );

        return false;
      })
      .then(function (result) {
        pending = null;
        return result;
      });

    return pending;
  }

  function delayedSync(data) {
    clearTimeout(timer);

    timer = setTimeout(
      function () {
        syncToCart(
          data,
          true
        );
      },
      800
    );
  }

  var fresh =
    captureFromUrl();

  var active =
    fresh
      ? mergeFresh(
          fresh,
          loadStored()
        )
      : loadStored();

  if (!valid(active)) {
    return;
  }

  save(active);

  /*
   * 新广告点击强制同步；
   * 缓存恢复在同一标签页只同步一次。
   */
  syncToCart(
    active,
    Boolean(fresh)
  );

  document.addEventListener(
    'click',
    function (event) {
      if (
        !event.target ||
        !event.target.closest
      ) {
        return;
      }

      /*
       * AJAX加入购物车后再补同步一次。
       */
      var addButton =
        event.target.closest(
          'button[name="add"],' +
          '[data-add-to-cart],' +
          'form[action*="/cart/add"] ' +
          'button[type="submit"]'
        );

      if (addButton) {
        delayedSync(active);
      }

      /*
       * 点击结账前保险同步。
       */
      var checkoutButton =
        event.target.closest(
          'button[name="checkout"],' +
          'input[name="checkout"],' +
          'a[href*="/checkout"],' +
          '[data-checkout-button],' +
          '.shopify-payment-button__button'
        );

      if (checkoutButton) {
        syncToCart(
          active,
          true
        );
      }
    },
    true
  );
})();